import { ReactNode } from 'react'

import BodyText from '../../../app/components/BodyText'

import styles from './CapacityConflictStepDescription.module.scss'

type CapacityConflictStepDescriptionProps = {
  children: ReactNode
}

export default function CapacityConflictStepDescription({
  children,
}: CapacityConflictStepDescriptionProps) {
  return (
    <BodyText color="body-1" className={styles.description}>
      {children}
    </BodyText>
  )
}
